import axios from 'axios';
import {
    isChecklistFlowActive,
    isChecklistSaveSuccess,
    triggerChecklistStepUpdateAfterSave
} from '@/helpers/checklistCompletion';
import { getAccessToken } from '@/helpers/authSession';

const baseCommonURL = process.env.VUE_APP_WebApiBaseUrl;
const baseURLCommon = `${baseCommonURL}`;

const instance = axios.create({
    baseURL: baseURLCommon
});

const toLower = (value) => String(value || '').trim().toLowerCase();
const isMutatingMethod = (method) => ['post', 'put', 'patch'].includes(toLower(method));

const shouldSkipUpdateForRequest = (config) => {
    const url = toLower(config?.url);
    return (
        url.includes('onboarding/updatestepstatus') ||
        url.includes('onboarding/') ||
        url.includes('coownerinvitation/saveinvitation')
    );
};

const applyAuthHeader = (config) => {
    // Primary key is access_token; getAccessToken also checks access_Token / token.
    const token = getAccessToken();
    if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization && !config.headers.authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
};

instance.interceptors.request.use(applyAuthHeader);

// Checklist completion interceptor only — auth/session logout is registered in
// setupInterceptors.js via attachAuthResponseInterceptor (keeps one logout path).
instance.interceptors.response.use(
    (response) => {
        const config = response?.config || {};
        if (
            config.completeChecklistStep === true &&
            isChecklistFlowActive() &&
            isMutatingMethod(config?.method) &&
            isChecklistSaveSuccess(response) &&
            !shouldSkipUpdateForRequest(config)
        ) {
            triggerChecklistStepUpdateAfterSave(response, response?.config?.data).catch(() => {
                // Checklist completion must never affect the user's save response
            });
        }
        return response;
    },
    (error) => Promise.reject(error)
);

export const completePendingChecklistStep = async () => {
    const onboardingService = (await import('./onboarding.service')).default;
    return onboardingService.completePendingChecklistStep();
};

export default instance;
